module.exports = __webpack_public_path__ + "static/media/dotted-line-icon.434cd26f.svg";